import { render, staticRenderFns } from "./ResendConfirmationToken.vue?vue&type=template&id=8cae6b04&"
import script from "./ResendConfirmationToken.vue?vue&type=script&lang=js&"
export * from "./ResendConfirmationToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports